module.exports = __webpack_public_path__ + "static/media/android.7aa5062b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app_icons/android.png
// module id = 445
// module chunks = 0